import type { ComponentProps } from "react";
import { DateField } from "@apac/form-ui";

export const BirthDateField = (props: ComponentProps<typeof DateField>) => {
  return <DateField {...props} />;
};
